<template>
    <button @click="cancelRequest" type="button" class="btn btn-link-success font-weight-bold font-xs text-green">
        <slot></slot>
    </button>
</template>
<script>
export default {
    props: {
        eventName: {
            type: String,
            default: ""
        }
    },
    methods: {
        cancelRequest() {
            let g4Params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': 'WT',
                'transaction_reference': this.$root.$data.referenceNumber,
            }       
            this.$root.triggerG4Event(this.eventName,g4Params)

            var vm = this;

            axios
                .post("lazada-hcpay/cancel_request?tid=" + this.$root.$data.transactionId)
                .then(response => {
                    this.$root.$data.view = "lazada-user-canceled";
                })
                .catch(error => {
                    this.$root.$data.view = "lazada-technical-issue";
                });
        }
    }
}
</script>